import React from 'react';

interface IconProps {
  className?: string;
}

export const PhoneIcon: React.FC<IconProps> = ({ className = 'w-3.5 h-3.5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

export const LocationPinIcon: React.FC<IconProps> = ({ className = 'w-3.5 h-3.5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
    <circle cx="12" cy="9" r="2.5" />
  </svg>
);

export const MapIcon: React.FC<IconProps> = ({ className = 'w-3.5 h-3.5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
    <line x1="8" y1="2" x2="8" y2="18" />
    <line x1="16" y1="6" x2="16" y2="22" />
  </svg>
);

export const ForkKnifeIcon: React.FC<IconProps> = ({ className = 'w-3.5 h-3.5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
    <path d="M7 2v20" />
    <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3zm0 0v7" />
  </svg>
);

export const ClockIcon: React.FC<IconProps> = ({ className = 'w-3.5 h-3.5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

export const GlobeIcon: React.FC<IconProps> = ({ className = 'w-3.5 h-3.5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

export const FeaturesIcon: React.FC<IconProps> = ({ className = 'w-3.5 h-3.5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

// ── Category icons for restaurant placeholders ──────────────────────────────

export const CoffeeIcon: React.FC<IconProps> = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
    <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
    <path d="M6 2v3M10 2v3" />
  </svg>
);

export const WineGlassIcon: React.FC<IconProps> = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 22h8M12 22v-7M5 3h14l-2.5 8A4.5 4.5 0 0 1 7.5 11L5 3z" />
  </svg>
);

export const PizzaIcon: React.FC<IconProps> = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2L2 20h20L12 2z" />
    <path d="M2 20Q12 17 22 20" />
    <circle cx="12" cy="13" r="0.8" fill="currentColor" stroke="none" />
    <circle cx="9.5" cy="16" r="0.8" fill="currentColor" stroke="none" />
    <circle cx="14.5" cy="16" r="0.8" fill="currentColor" stroke="none" />
  </svg>
);

export const BreadIcon: React.FC<IconProps> = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12a6 6 0 0 1 18 0v8H3v-8z" />
    <path d="M3 15h18" />
  </svg>
);

export const CakeIcon: React.FC<IconProps> = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 22V14a8 8 0 0 1 16 0v8H4z" />
    <path d="M4 17h16" />
    <path d="M12 6V3" />
    <circle cx="12" cy="3" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const BurgerIcon: React.FC<IconProps> = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 13h16M4 17h16" />
    <path d="M4 9Q12 5 20 9H4z" />
    <path d="M4 17Q12 21 20 17" />
  </svg>
);

export const MusicNoteIcon: React.FC<IconProps> = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
);

export const BowlIcon: React.FC<IconProps> = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 11a8 8 0 0 0 16 0H4z" />
    <path d="M3 11h18" />
    <path d="M12 3v4M9 4v3M15 4v3" />
  </svg>
);

export const SushiIcon: React.FC<IconProps> = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="12" rx="9" ry="6" />
    <ellipse cx="12" cy="12" rx="5" ry="3" />
    <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
  </svg>
);

export const DeliveryIcon: React.FC<IconProps> = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 17H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3" />
    <rect x="9" y="11" width="14" height="10" rx="2" />
    <circle cx="12" cy="21" r="1" /><circle cx="20" cy="21" r="1" />
  </svg>
);

// ── CategoryPlaceholder ──────────────────────────────────────────────────────

interface CategoryPlaceholderProps {
  rubrics?: string[];
  cuisine?: string;
  className?: string;
  iconClassName?: string;
}

type CategoryRule = {
  test: (rubrics: string[], cuisine: string) => boolean;
  bg: string;
  iconColor: string;
  Icon: React.FC<IconProps>;
};

const CATEGORY_RULES: CategoryRule[] = [
  {
    test: (r, c) => r.some(x => /кофейн/i.test(x)) || /кофе|кофейн/i.test(c),
    bg: 'bg-amber-50', iconColor: 'text-amber-400', Icon: CoffeeIcon,
  },
  {
    test: (r, c) => r.some(x => /суши/i.test(x)) || /суши|ролл/i.test(c),
    bg: 'bg-sky-50', iconColor: 'text-sky-400', Icon: SushiIcon,
  },
  {
    test: (r, c) => r.some(x => /пицц/i.test(x)) || /пицц/i.test(c),
    bg: 'bg-red-50', iconColor: 'text-red-400', Icon: PizzaIcon,
  },
  {
    test: (r, c) => r.some(x => /пекарн/i.test(x)) || /пекарн|булочн|хлеб/i.test(c),
    bg: 'bg-yellow-50', iconColor: 'text-yellow-500', Icon: BreadIcon,
  },
  {
    test: (r, c) => r.some(x => /кондитер/i.test(x)) || /кондитер|торт|десерт/i.test(c),
    bg: 'bg-pink-50', iconColor: 'text-pink-400', Icon: CakeIcon,
  },
  {
    test: (r, c) => r.some(x => /быстрое питание/i.test(x)) || /бургер|шаурм|хот-дог|фаст/i.test(c),
    bg: 'bg-orange-50', iconColor: 'text-orange-400', Icon: BurgerIcon,
  },
  {
    test: (r, c) => r.some(x => /доставка/i.test(x)) || /доставк/i.test(c),
    bg: 'bg-teal-50', iconColor: 'text-teal-400', Icon: DeliveryIcon,
  },
  {
    test: (r, c) => r.some(x => /ночн|клуб/i.test(x)) || /ночн|клуб/i.test(c),
    bg: 'bg-indigo-50', iconColor: 'text-indigo-400', Icon: MusicNoteIcon,
  },
  {
    test: (r, c) => r.some(x => /бар/i.test(x)) || /\bбар\b|паб|пиво/i.test(c),
    bg: 'bg-purple-50', iconColor: 'text-purple-400', Icon: WineGlassIcon,
  },
  {
    test: (r, c) => r.some(x => /столов|кулинар/i.test(x)) || /столов|бистро|кулинар/i.test(c),
    bg: 'bg-green-50', iconColor: 'text-green-500', Icon: BowlIcon,
  },
  {
    test: (r, c) => r.some(x => /кафе/i.test(x)) || /кафе/i.test(c),
    bg: 'bg-amber-50', iconColor: 'text-amber-400', Icon: CoffeeIcon,
  },
];

export const CategoryPlaceholder: React.FC<CategoryPlaceholderProps> = ({
  rubrics = [],
  cuisine = '',
  className = '',
  iconClassName = 'w-6 h-6',
}) => {
  const rule = CATEGORY_RULES.find(r => r.test(rubrics, cuisine));
  const bg = rule?.bg ?? 'bg-gray-100';
  const iconColor = rule?.iconColor ?? 'text-gray-300';
  const Icon = rule?.Icon ?? ForkKnifeIcon;

  return (
    <div className={`${bg} ${className} flex items-center justify-center`}>
      <Icon className={`${iconColor} ${iconClassName}`} />
    </div>
  );
};
